document.querySelectorAll('#menu-jezyki > li > a').forEach((link) => {
    link.addEventListener('click', (e) => {
        e.preventDefault();

        link.parentElement.querySelectorAll(':scope > .sub-menu').forEach((subMenu) => {
            subMenu.style.display = getComputedStyle(subMenu).display === 'none' ? 'block' : 'none';
        });
    });
});

const dropdowns = document.querySelectorAll('#navbarNavDropdown .dropdown');

function toggleDropdown(dropdown, open) {
    dropdown.classList.toggle('show', open);
    dropdown.querySelectorAll('.dropdown-menu').forEach((menu) => menu.classList.toggle('show', open));
}

if (document.documentElement.clientWidth > 992) {
    dropdowns.forEach((dropdown) => {
        dropdown.addEventListener('mouseenter', () => toggleDropdown(dropdown, true));
        dropdown.addEventListener('mouseleave', () => toggleDropdown(dropdown, false));
    });
} else {
    // Tapping the label (the <span>) follows the link, tapping the rest of it opens the submenu.
    document.querySelectorAll('#navbarNavDropdown .dropdown > a').forEach((link) => {
        link.addEventListener('click', (e) => {
            if (e.target.tagName.toLowerCase() !== 'span') {
                e.preventDefault();
                toggleDropdown(link.parentElement);
            }
        });
    });
}

document.addEventListener('change', (e) => {
    const input = e.target.closest('.cv-file input[type="file"]');
    if (!input) {
        return;
    }

    const fileName = input.files.length ? input.files[0].name : 'Nie wybrano pliku';
    input.parentElement.querySelectorAll(':scope > .filename').forEach((label) => {
        label.textContent = fileName;
    });
});

window.addEventListener('load', () => {
    const video = document.getElementById('bg-video');
    if (!video || !video.dataset.src) {
        return;
    }

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const saveData = navigator.connection?.saveData;
    if (reducedMotion || saveData) {
        return;
    }

    video.addEventListener('playing', () => video.classList.add('is-playing'), { once: true });
    video.src = video.dataset.src;
    video.play().catch(() => {});
});

if (window.fwcRecaptcha?.src) {
    const waiting = [];
    let loading = null;

    const loadRecaptcha = () => {
        if (!loading) {
            loading = new Promise((resolve, reject) => {
                delete window.grecaptcha;
                const script = document.createElement('script');
                script.src = window.fwcRecaptcha.src;
                script.async = true;
                script.onload = () => window.grecaptcha.ready(() => {
                    waiting.forEach((callback) => window.grecaptcha.ready(callback));
                    resolve(window.grecaptcha);
                });
                script.onerror = reject;
                document.head.appendChild(script);
            });
        }
        return loading;
    };

    window.grecaptcha = {
        ready: (callback) => waiting.push(callback),
        execute: (...args) => loadRecaptcha().then((grecaptcha) => grecaptcha.execute(...args)),
    };

    const onFormInteraction = (event) => {
        if (event.target instanceof Element && event.target.closest('form.wpcf7-form')) {
            loadRecaptcha();
        }
    };
    ['focusin', 'pointerdown', 'touchstart'].forEach((type) => {
        document.addEventListener(type, onFormInteraction, { passive: true });
    });
}
